import $$ from 'cmn-utils'

const baseUrl = "/user/";
export default {
    login: (params) => {
        return $$.post(baseUrl + 'login', params)
    },
}
